export const types = {
  notificacionesLoaded: "[notificacion] notificaciones Loaded",
  notificacionSetActive: "[notificacion] notificacion Set Active",
  notificacionClearActive: "[notificacion] notificacion Clear Active",
  notificacionAdded: "[notificacion] notificacion added",
  notificacionUpdated: "[notificacion] notificacion updated",
  notificacionDeleted: "[notificacion] notificacion deleted",
  notificacionLoading: "[notificacion] notificacion Loading Data",
  notificacionLogout: "[notificacion] notificacion logout",
};
